
// /* eslint-disable */
const PLAY_THRESHOLD = 200
const AudioPlayer = () => {

  const optionSound = document.querySelector('[option-sound]')
  const optionMute = document.querySelector('[option-mute]')

  // optionSound?.addEventListener('click', autoPlay)
  // optionMute?.addEventListener('click', manualPlay)
  manualPlay()


  function autoPlay() {
    let prevSection: number | null = -1
    const sections = document.querySelectorAll('[dk-section]') as any[];
    const innerWindow = document.getElementById('inner-window');

    const sectionOffsets = [...sections].map(section => {
      return section.offsetTop
    })

    innerWindow?.addEventListener('scroll', function () {
      let currentSection: number | null = -1
      const scrollTop = innerWindow.scrollTop
      sectionOffsets.forEach((offset, index) => {
        if (offset - PLAY_THRESHOLD < scrollTop && currentSection !== null) {
          currentSection = index
        }
      })

      if (currentSection !== prevSection) {
        if (currentSection === sectionOffsets.length - 1 && scrollTop > sectionOffsets[sectionOffsets.length - 1] + sections[sections.length - 1].offsetHeight) {
          currentSection = null
        }

        if (prevSection !== null && prevSection !== -1) {
          const prevAudioPlayer = document.querySelectorAll('[dk-audio-player]')[prevSection]
          function aud_fade() {
           
            if (prevAudioPlayer && prevAudioPlayer.volume > 0) {
              prevAudioPlayer.volume -= Math.min(prevAudioPlayer.volume, 0.2);
              setTimeout(aud_fade, 300);
            }
          }
          aud_fade()
          const activeIcon = document.querySelectorAll('[dk-muted]')[currentSection]
          activeIcon?.setAttribute('style', 'visibility: visible;')
        }

        if (currentSection !== null && currentSection !== -1 && currentSection !== 6) {
          const activeIcon = document.querySelectorAll('[dk-muted]')[currentSection]
          const audioPlayer = document.querySelectorAll('[dk-audio-player]')[currentSection]
          if (audioPlayer) {
            audioPlayer.play()
            audioPlayer.volume = 1;
            audioPlayer.loop = true
            activeIcon?.setAttribute('style', 'visibility: hidden;')
          } 
        }

        prevSection = currentSection
      }
    })
  }


  function manualPlay() {
    let prevSection: number | null = -1
    const sections = document.querySelectorAll('[dk-section]') as any[];
    const innerWindow = document.getElementById('inner-window');

    const sectionOffsets = [...sections].map(section => {
      return section.offsetTop
    })

    innerWindow?.addEventListener('scroll', function () {
      let currentSection: number | null = -1
      const scrollTop = innerWindow.scrollTop
      sectionOffsets.forEach((offset, index) => {
        if (offset - PLAY_THRESHOLD < scrollTop && currentSection !== null) {
          currentSection = index
        }
      })
      if (currentSection !== prevSection) {
        if (currentSection === sectionOffsets.length - 1 && scrollTop > sectionOffsets[sectionOffsets.length - 1] + sections[sections.length - 1].offsetHeight) {
          currentSection = null
        }

        if (prevSection !== null && prevSection !== -1) {
          const prevAudioPlayer = document.querySelectorAll('[dk-audio-player]')[prevSection]
          // prevAudioPlayer.pause()
          function aud_fade_out() {
            if (prevAudioPlayer && prevAudioPlayer.volume > 0) {
              prevAudioPlayer.volume -= Math.min(prevAudioPlayer.volume, 0.2);
              setTimeout(aud_fade_out, 300);
            }
          }
          aud_fade_out()
          const activeIcon = document.querySelectorAll('[dk-muted]')[currentSection]
          activeIcon?.setAttribute('style', 'visibility: visible;')
        }
        prevSection = currentSection
      }
    })
  }



  function runCustomPlayer1() {
    const marshSound = document.querySelector('[dk-toggler-marshes]');
    const audioPlayerMarshes = document.querySelector('[dk-audio-player-marshes]');
    const activeIconMarshes = document.querySelector('[dk-muted-marshes]')

    marshSound?.addEventListener('click', function (e) {
      const src = e?.target?.parentNode.dataset.audiosrc;
      if (audioPlayerMarshes!.paused) {
        audioPlayerMarshes?.setAttribute('src', src);
        audioPlayerMarshes!.play()
        audioPlayerMarshes.volume = 1
        activeIconMarshes?.setAttribute('style', 'visibility: hidden;')
      } else {
        audioPlayerMarshes!.pause()
        activeIconMarshes?.setAttribute('style', 'visibility: visible;')
      }
      const playAudioIconText = e?.target?.closest('.audio-icon-wrapper').querySelector('.audio-icon-text.play');
      const pauseAudioIconText = e?.target?.closest('.audio-icon-wrapper').querySelector('.audio-icon-text.pause');
      playAudioIconText.classList.toggle('hidden');
      pauseAudioIconText.classList.toggle('hidden');
    });
  }

  function runCustomPlayer2() {

    const mangroveSound = document.querySelector('[dk-toggler-mangroves]');
    const audioPlayerMangroves = document.querySelector('[dk-audio-player-mangroves]');
    const activeIconMangroves = document.querySelector('[dk-muted-mangroves]')

    mangroveSound?.addEventListener('click', function (e) {
      const src = e?.target?.parentNode.dataset.audiosrc;
      if (audioPlayerMangroves!.paused) {
        audioPlayerMangroves?.setAttribute('src', src);
        audioPlayerMangroves!.play()
        audioPlayerMangroves.volume = 1
        activeIconMangroves?.setAttribute('style', 'visibility: hidden;')
      } else {
        audioPlayerMangroves!.pause()
        activeIconMangroves?.setAttribute('style', 'visibility: visible;')
      }
      const playAudioIconText = e?.target?.closest('.audio-icon-wrapper').querySelector('.audio-icon-text.play');
      const pauseAudioIconText = e?.target?.closest('.audio-icon-wrapper').querySelector('.audio-icon-text.pause');
      playAudioIconText.classList.toggle('hidden');
      pauseAudioIconText.classList.toggle('hidden');
    });
  }

  function runCustomPlayer3() {

    const seaweedSound = document.querySelector('[dk-toggler-seaweed]');
    const audioPlayerSeaweed = document.querySelector('[dk-audio-player-seaweed]');
    const activeIconSeaweed = document.querySelector('[dk-muted-seaweed]')

    seaweedSound?.addEventListener('click', function (e) {
      const src = e?.target?.parentNode.dataset.audiosrc;
      if (audioPlayerSeaweed!.paused || audioPlayerSeaweed!.muted) {
        audioPlayerSeaweed?.setAttribute('src', src);
        audioPlayerSeaweed!.play()
        audioPlayerSeaweed!.volume = 1

        activeIconSeaweed?.setAttribute('style', 'visibility: hidden;')
      } else {
        audioPlayerSeaweed!.pause()
        activeIconSeaweed?.setAttribute('style', 'visibility: visible;')
      }
      const playAudioIconText = e?.target?.closest('.audio-icon-wrapper').querySelector('.audio-icon-text.play');
      const pauseAudioIconText = e?.target?.closest('.audio-icon-wrapper').querySelector('.audio-icon-text.pause');
      playAudioIconText.classList.toggle('hidden');
      pauseAudioIconText.classList.toggle('hidden');
    });
  }

  function runCustomPlayer4() {

    const mesoSound = document.querySelector('[dk-toggler-meso]');
    const audioPlayerMeso = document.querySelector('[dk-audio-player-meso]');
    const activeIconMeso = document.querySelector('[dk-muted-meso]')

    mesoSound?.addEventListener('click', function (e) {
      const src = e?.target?.parentNode.dataset.audiosrc;
      if (audioPlayerMeso!.paused) {
        audioPlayerMeso?.setAttribute('src', src);
        audioPlayerMeso!.play()
        audioPlayerMeso.volume = 1
        activeIconMeso?.setAttribute('style', 'visibility: hidden;')
      } else {
        audioPlayerMeso!.pause()
        activeIconMeso?.setAttribute('style', 'visibility: visible;')
      }
      const playAudioIconText = e?.target?.closest('.audio-icon-wrapper').querySelector('.audio-icon-text.play');
      const pauseAudioIconText = e?.target?.closest('.audio-icon-wrapper').querySelector('.audio-icon-text.pause');
      playAudioIconText.classList.toggle('hidden');
      pauseAudioIconText.classList.toggle('hidden');
    });
  }

  function runCustomPlayer5() {

    const whaleSound = document.querySelector('[dk-toggler-whale]');
    const audioPlayerWhale = document.querySelector('[dk-audio-player-whale]');
    const activeIconWhale = document.querySelector('[dk-muted-whale]')

    whaleSound?.addEventListener('click', function (e) {
      const src = e?.target?.parentNode.dataset.audiosrc;
      if (audioPlayerWhale!.paused) {
        audioPlayerWhale?.setAttribute('src', src);
        audioPlayerWhale!.play()
        audioPlayerWhale.volume = 1
        activeIconWhale?.setAttribute('style', 'visibility: hidden;')
      } else {
        audioPlayerWhale!.pause()
        activeIconWhale?.setAttribute('style', 'visibility: visible;')
      }
      const playAudioIconText = e?.target?.closest('.audio-icon-wrapper').querySelector('.audio-icon-text.play');
      const pauseAudioIconText = e?.target?.closest('.audio-icon-wrapper').querySelector('.audio-icon-text.pause');
      playAudioIconText.classList.toggle('hidden');
      pauseAudioIconText.classList.toggle('hidden');
    });
  }

  runCustomPlayer1()
  runCustomPlayer2()
  runCustomPlayer3()
  runCustomPlayer4()
  runCustomPlayer5()
}

export default AudioPlayer


